import { computed, makeObservable, observable } from "mobx"

import type { IEpochStore } from "./interfaces"
import type { EpochStoreDAO } from "./types"

export class EpochStore implements IEpochStore {
  epochNumber: number
  startTimestamp: number
  dists: string
  weekly: string
  mints: string
  gaugesMint: string
  mintBlockNumber: number
  recycled: string
  pool2Mint: string
  teamMint: string
  recycledPercentage: number
  freshPercentage: number
  circulatingEmission: string
  circulatingSupply: string

  constructor(data: EpochStoreDAO) {
    this.epochNumber = data.epochNumber
    this.startTimestamp = data.startTimestamp
    this.dists = data.dists
    this.weekly = data.weekly
    this.mints = data.mints
    this.gaugesMint = data.gaugesMint
    this.mintBlockNumber = data.mintBlockNumber
    this.recycled = data.recycled
    this.pool2Mint = data.pool2Mint
    this.teamMint = data.teamMint
    this.recycledPercentage = data.recycledPercentage
    this.freshPercentage = data.freshPercentage
    this.circulatingEmission = data.circulatingEmission
    this.circulatingSupply = data.circulatingSupply

    makeObservable(this, {
      epochNumber: observable,
      startTimestamp: observable,
      dists: observable,
      weekly: observable,
      mints: observable,
      gaugesMint: observable,
      mintBlockNumber: observable,
      recycled: observable,
      pool2Mint: observable,
      teamMint: observable,
      recycledPercentage: observable,
      freshPercentage: observable,
      circulatingEmission: observable,
      circulatingSupply: observable,
    })
  }

  /**
   * Update epoch data (for when current epoch is refreshed)
   */
  updateData(data: Partial<EpochStoreDAO>): void {
    if (data.epochNumber !== undefined) {
      this.epochNumber = data.epochNumber
    }
    if (data.startTimestamp !== undefined) {
      this.startTimestamp = data.startTimestamp
    }
    if (data.dists !== undefined) {
      this.dists = data.dists
    }
    if (data.weekly !== undefined) {
      this.weekly = data.weekly
    }
    if (data.mints !== undefined) {
      this.mints = data.mints
    }
    if (data.gaugesMint !== undefined) {
      this.gaugesMint = data.gaugesMint
    }
    if (data.mintBlockNumber !== undefined) {
      this.mintBlockNumber = data.mintBlockNumber
    }
    if (data.recycled !== undefined) {
      this.recycled = data.recycled
    }
    if (data.pool2Mint !== undefined) {
      this.pool2Mint = data.pool2Mint
    }
    if (data.teamMint !== undefined) {
      this.teamMint = data.teamMint
    }
    if (data.recycledPercentage !== undefined) {
      this.recycledPercentage = data.recycledPercentage
    }
    if (data.freshPercentage !== undefined) {
      this.freshPercentage = data.freshPercentage
    }
    if (data.circulatingEmission !== undefined) {
      this.circulatingEmission = data.circulatingEmission
    }
    if (data.circulatingSupply !== undefined) {
      this.circulatingSupply = data.circulatingSupply
    }
  }
}
